"use strict";
/**
 * Structural-equality helpers for the Settings editor. All comparisons
 * route through {@link sanitizeAiHubSettingsSchema} first so transient
 * markers (`__clientId`, empty optional records) and key-order differences
 * never produce phantom "unsaved changes".
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAiHubSettingsFieldChanged = exports.hasAiHubSettingsSystemChanged = exports.areAiHubSettingsSchemasEqual = void 0;
var ai_hub_settings_sanitization_1 = require("./ai-hub-settings-sanitization");
/**
 * Compare two schemas after normalization.
 */
exports.areAiHubSettingsSchemasEqual = function (left, right) {
    return JSON.stringify(ai_hub_settings_sanitization_1.sanitizeAiHubSettingsSchema(left)) ===
        JSON.stringify(ai_hub_settings_sanitization_1.sanitizeAiHubSettingsSchema(right));
};
var sanitizeSingleSystem = function (system) {
    return ai_hub_settings_sanitization_1.sanitizeAiHubSettingsSchema({ systems: [system], workflows: [], fields: [] }).systems[0];
};
var sanitizeSingleField = function (field) {
    return ai_hub_settings_sanitization_1.sanitizeAiHubSettingsSchema({ systems: [], workflows: [], fields: [field] }).fields[0];
};
/**
 * Compare two systems after normalization.
 */
exports.hasAiHubSettingsSystemChanged = function (currentSystem, savedSystem) {
    if (!savedSystem) {
        return true;
    }
    return (JSON.stringify(sanitizeSingleSystem(currentSystem)) !==
        JSON.stringify(sanitizeSingleSystem(savedSystem)));
};
/**
 * Compare two fields after normalization.
 */
exports.hasAiHubSettingsFieldChanged = function (currentField, savedField) {
    if (!savedField) {
        return true;
    }
    return (JSON.stringify(sanitizeSingleField(currentField)) !==
        JSON.stringify(sanitizeSingleField(savedField)));
};
